import PropTypes from 'prop-types';

/*
See ./index.js for notes on naming conventions
*/

// Only rely on the V1 slugs so filter selections can transfer across search experiences.
// V2-CLEANUP: We can update these to the V2 slugs if we want, after all search experiences are on V2.
const AMENITY_SLUGS_V1 = [
    'covered',
    'ev',
    'immediate-parking',
    'in-out',
    'no-contract',
    'one-tap',
    'paved',
    'self-park',
    'shuttle',
    'touchless',
    'valet',
    'wheelchair',
    'heated',
];

export const PROPTYPE_PRICE = PropTypes.shape({
    currencyCode: PropTypes.oneOf(['CAD', 'USD']).isRequired,
    value: PropTypes.number.isRequired,
});

export const PROPTYPE_AVAILABILITY = PropTypes.shape({
    available: PropTypes.bool.isRequired,
    unavailableReasons: PropTypes.arrayOf(PropTypes.string).isRequired,
});

const OBJECT_PRICE_BREAKDOWN = {
    fullDescription: PropTypes.string,
    price: PROPTYPE_PRICE.isRequired,
    shortDescription: PropTypes.string.isRequired,
    // TODO: should this be an enum? question out to BE
    type: PropTypes.string.isRequired,
};

export const PROPTYPE_PRICE_BREAKDOWN = PropTypes.shape(OBJECT_PRICE_BREAKDOWN);

// common details provided as part of any rate
export const OBJECT_BASE_RATE_DETAILS = {
    ends: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PROPTYPE_PRICE_BREAKDOWN).isRequired,
    rateId: PropTypes.string.isRequired,
    starts: PropTypes.string.isRequired,
    totalPrice: PROPTYPE_PRICE.isRequired,
    fullUrl: PropTypes.string.isRequired,
};

export const PROPTYPE_BASE_RATE = PropTypes.shape(OBJECT_BASE_RATE_DETAILS);

// rate info provided as part of the default rate for a given facility
export const OBJECT_COMMON_RATE = {
    ...OBJECT_BASE_RATE_DETAILS,
    advertisedPrice: PROPTYPE_PRICE.isRequired,
    amenities: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string.isRequired,
            type: PropTypes.oneOf(AMENITY_SLUGS_V1).isRequired,
        }).isRequired
    ).isRequired,
    redemptionType: PropTypes.oneOf([
        'self',
        'valet',
        'self_valet_assist',
        'premium_valet',
    ]).isRequired,
};

// rollup that combines all rate data defined in the given rate
export const OBJECT_COMMON_RATE_ROLLUP = {
    default: PropTypes.shape(OBJECT_COMMON_RATE),
    packagePlans: PropTypes.arrayOf(PropTypes.shape(OBJECT_BASE_RATE_DETAILS)),
};
